import { AccountSettingsCard } from "../../../components/ops/AccountSettingsCard";
import { PageHeader } from "../../../components/ops/PageHeader";

export function StaffSettingsPage() {
  return (
    <div>
      <PageHeader title="Settings" subtitle="Manage your staff profile" />
      <AccountSettingsCard />
    </div>
  );
}
